export default {
      id: "help-white-usage",
      viewBox: "0 0 25 25",
      url: "images/" + "sprite.svg#help-white-usage",
      toString: function () {
        return this.url;
      }
    }